import { Flex, Icon } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import {
  ratingOptions,
  getSelectionRatingStyle,
} from '@/constants/scorecard-configs';
import { ScorecardRating } from '../GenerateScorecard.interface';

interface ScorecardPDFRatingProps {
  rating: ScorecardRating;
  size?: 'sm' | 'md';
}

export const ScorecardPDFRating = ({
  rating,
  size = 'md',
}: ScorecardPDFRatingProps) => {
  if (!rating) {
    return (
      <Flex
        gap="4px"
        alignItems="center"
        borderRadius="4px"
        bg="secondary-100"
        p="2px 8px"
        w="fit-content"
      >
        <KText size="sm-medium" color="secondary-700">
          Not rated
        </KText>
      </Flex>
    );
  }

  const ratingConfig = ratingOptions?.find((item) => item?.value === rating);
  const scorecardStyles = getSelectionRatingStyle(ratingConfig);

  const iconSize = size === 'sm' ? '16px' : '20px';
  const textSize = size === 'sm' ? 'xs-medium' : 'sm-medium';

  return (
    <Flex
      gap="4px"
      alignItems="center"
      borderRadius="4px"
      bg={ratingConfig?.bgColor}
      p="2px 8px"
    >
      <Icon
        as={ratingConfig?.icon}
        w={iconSize}
        h={iconSize}
        color={ratingConfig?.selectedColor}
        {...scorecardStyles}
      />
      <KText size={textSize} color={ratingConfig?.selectedColor}>
        {ratingConfig?.label}
      </KText>
    </Flex>
  );
};
